import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { StyledTooltipTag } from './styled'; // We need to use a custom tag element in our tooltip to prevent extra whitespace being rendered after the element

export var TooltipTag = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledTooltipTag, _extends({
    innerRef: ref
  }, props));
});